(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _utmHelper = _interopRequireDefault(require("impv/src/js/components/utm-helper"));

require("impv/src/js/components/jquery-sameheight");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Carry UTMs
// get GTM across pages
var utmHelperInstance = new _utmHelper["default"]();
utmHelperInstance.retrieveUTMParam('utm-params');
jQuery(function () {
  initSameHeight();
}); // align blocks height

function initSameHeight() {
  jQuery('.right-column').sameHeight({
    elements: '.carousel-item',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
}

},{"impv/src/js/components/jquery-sameheight":3,"impv/src/js/components/utm-helper":4}],2:[function(require,module,exports){
"use strict";

require("impv-main/src/js/contact-us-page-awesome");

},{"impv-main/src/js/contact-us-page-awesome":1}],3:[function(require,module,exports){
"use strict";

/*
 * jQuery SameHeight plugin
 */
(function ($) {
  $.fn.sameHeight = function (opt) {
    var options = $.extend({
      skipClass: 'same-height-ignore',
      leftEdgeClass: 'same-height-left',
      rightEdgeClass: 'same-height-right',
      elements: '>*',
      flexible: false,
      multiLine: false,
      useMinHeight: false,
      biggestHeight: false
    }, opt);
    return this.each(function () {
      var holder = $(this),
          postResizeTimer,
          ignoreResize;
      var elements = holder.find(options.elements).not('.' + options.skipClass);
      if (!elements.length) return; // resize handler

      function doResize() {
        elements.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', '');

        if (options.multiLine) {
          // resize elements row by row
          resizeElementsByRows(elements, options);
        } else {
          // resize elements by holder
          resizeElements(elements, holder, options);
        }
      }

      doResize(); // handle flexible layout / font resize

      var delayedResizeHandler = function delayedResizeHandler() {
        if (!ignoreResize) {
          ignoreResize = true;
          doResize();
          clearTimeout(postResizeTimer);
          postResizeTimer = setTimeout(function () {
            doResize();
            setTimeout(function () {
              ignoreResize = false;
            }, 10);
          }, 100);
        }
      }; // handle flexible/responsive layout


      if (options.flexible) {
        $(window).bind('resize orientationchange fontresize', delayedResizeHandler);
      } // handle complete page load including images and fonts


      $(window).bind('load', delayedResizeHandler);
    });
  }; // detect css min-height support


  var supportMinHeight = typeof document.documentElement.style.maxHeight !== 'undefined'; // get elements by rows

  function resizeElementsByRows(boxes, options) {
    var currentRow = $(),
        maxHeight,
        maxCalcHeight = 0,
        firstOffset = boxes.eq(0).offset().top;
    boxes.each(function (ind) {
      var curItem = $(this);
      /* 
        Determine if a new row starts by distance of box from top offset. 
        Run math functions to "smooth" slight discrepancies 
        '< 3' is a 3 pixel "wiggle room" 
      */

      if (Math.trunc(Math.abs(curItem.offset().top - firstOffset)) < 3) {
        currentRow = currentRow.add(this);
      } else {
        maxHeight = getMaxHeight(currentRow);
        maxCalcHeight = Math.max(maxCalcHeight, resizeElements(currentRow, maxHeight, options));
        currentRow = curItem;
        firstOffset = curItem.offset().top;
      }
    });

    if (currentRow.length) {
      maxHeight = getMaxHeight(currentRow);
      maxCalcHeight = Math.max(maxCalcHeight, resizeElements(currentRow, maxHeight, options));
    }

    if (options.biggestHeight) {
      boxes.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', maxCalcHeight);
    }
  } // calculate max element height


  function getMaxHeight(boxes) {
    var maxHeight = 0;
    boxes.each(function () {
      maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });
    return maxHeight;
  } // resize helper function


  function resizeElements(boxes, parent, options) {
    var calcHeight;
    var parentHeight = typeof parent === 'number' ? parent : parent.height();
    boxes.removeClass(options.leftEdgeClass).removeClass(options.rightEdgeClass).each(function (i) {
      var element = $(this);
      var depthDiffHeight = 0;
      var isBorderBox = element.css('boxSizing') === 'border-box' || element.css('-moz-box-sizing') === 'border-box' || element.css('-webkit-box-sizing') === 'border-box';

      if (typeof parent !== 'number') {
        element.parents().each(function () {
          var tmpParent = $(this);

          if (parent.is(this)) {
            return false;
          } else {
            depthDiffHeight += tmpParent.outerHeight() - tmpParent.height();
          }
        });
      }

      calcHeight = parentHeight - depthDiffHeight;
      calcHeight -= isBorderBox ? 0 : element.outerHeight() - element.height();

      if (calcHeight > 0) {
        element.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', calcHeight);
      }
    });
    boxes.filter(':first').addClass(options.leftEdgeClass);
    boxes.filter(':last').addClass(options.rightEdgeClass);
    return calcHeight;
  }
})(jQuery);

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UTMHelper =
/*#__PURE__*/
function () {
  function UTMHelper() {
    _classCallCheck(this, UTMHelper);
  }

  _createClass(UTMHelper, [{
    key: "storeUTMParam",
    // get GTM parameters in URL if it exists
    value: function storeUTMParam(sessionName) {
      // set the utm paramters in sessionStorage
      var utmSession = sessionStorage.getItem(sessionName); // only run if there are no sessionStorage

      if (utmSession == null) {
        // began new query string
        var utmStr = ''; // cannot use index because we cannot assume all parameters are utm parameters

        var numOfParams = 0;

        var urlStr = window.location.search.substring(1),
            urlStrArr = urlStr.split('&'),
            isAlphaNumeric = function isAlphaNumeric(str) {
          return /^[a-zA-Z0-9-_]+$/gi.test(str);
        };

        urlStrArr.forEach(function (val) {
          var kvpair = val.split('='),
              key = kvpair[0],
              strvalue = kvpair[1];

          if ((key === 'utm_medium' || key === 'utm_source' || key === 'utm_campaign' || key === 'utm_content' || key === 'utm_device' || key === 'utm_matchtype' || key === 'utm_term' || key === 'utm_parent' || key === 'utm_destination' || key === 'utm_category' || key === 'Lead-Source') && isAlphaNumeric(strvalue)) {
            if (numOfParams > 0) utmStr += '&'; // add ampersand query separators

            utmStr += val; // add key value

            numOfParams++; // increment only num of utm parameters
          }
        }); // set the utm paramters in sessionStorage if there are parameters

        if (numOfParams > 0) {
          // const sanitizedUTM = encodeURI(utmStr);
          sessionStorage.setItem(sessionName, utmStr);
        }
      } // run retrieve UTM if one exists
      else {
          this.retrieveUTMParam(sessionName);
        }
    }
  }, {
    key: "retrieveUTMParam",
    value: function retrieveUTMParam(sessionName) {
      // set the utm paramters in sessionStorage
      var utmSession = sessionStorage.getItem(sessionName),
          urlStr = window.location.search;
      console.log('Retrieve UTM'); // TODO: monitor then remove
      // if session exists, append to url, only if a utm_ paramter does not exist

      if (utmSession && !urlStr.includes('utm_')) {
        // determine whether to append or replace on the URL
        var finalQuery = urlStr ? urlStr + '&' + utmSession : '?' + utmSession;
        window.history.pushState('', document.title, finalQuery);
      } // reset the new parameter session storage
      else if (utmSession && urlStr.includes('utm_')) {
          sessionStorage.removeItem(sessionName);
          this.storeUTMParam(sessionName);
        }
    }
  }]);

  return UTMHelper;
}();

exports["default"] = UTMHelper;

},{}]},{},[2]);
